/* template */
<template><div class="mpx-root-view"><div class="train-container"><QueryCard/><template v-if="(!isAliAndNotLogin)"><Schedule :mixinShowProp="(mixinShowProp)"/><LoginCard v-if="(homePageData?.need_mandatory_login)"/><Diamonds :diamondsConf="(diamondsConf)" @pageGoTo="pageGoTo" class="diamonds"/><CouponBanner useTab v-if="(gotCoupons)"/><Ad :config="(adApllloConfig)"/></template><Service :notices="(notices)" :isJhAliMini="(isJhAliMini)"/><Slogan/></div><FallingPopup :fallingConf="(homePageFallingConf)" v-if="(gotCoupons)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m89b8fdf6"}'>
  .train-container
    box-sizing border-box
    height auto
    padding 0 10px
    .diamonds
      margin 8px auto
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m89b8fdf6"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex89b8fdf6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex89b8fdf6%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m89b8fdf6"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index89b8fdf6/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'LoginCard':getComponent(require("../../../../components/login-card.mpx?isComponent&outputPath=components%2Flogin-card99f1ea5e%2Findex")),'Diamonds':getComponent(require("../diamonds/index.mpx?isComponent&outputPath=components%2Findex2d8bbd20%2Findex")),'Slogan':getComponent(require("../../../../components/slogan/index.mpx?isComponent&outputPath=components%2Findexee4c3584%2Findex")),'Ad':getComponent(require("../ad/index.mpx?isComponent&outputPath=components%2Findex50dd8fe4%2Findex")),'QueryCard':getComponent(require("../query-card-train/index.mpx?isComponent&outputPath=components%2Findex77e2731e%2Findex")),'Schedule':getComponent(require("../schedule/index.mpx?isComponent&outputPath=components%2Findex14577018%2Findex")),'Service':getComponent(require("../../../../components/home-service/index.mpx?isComponent&outputPath=components%2Findex49c10132%2Findex")),'FallingPopup':getComponent(require("../../../../components/falling-popup/index.mpx?isComponent&outputPath=components%2Findex2960665a%2Findex")),'CouponBanner':getComponent(require("../../../../components/coupon/coupon-banner/index.mpx?isComponent&outputPath=components%2Findex49abbe6a%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
